export enum OsType {
  UNKNOWN,
  WINDOWS,
  LINUX,
  MAC,
  IOS,
  ANDROID
}
